import { eventBus } from './eventBus.js'
import { endpoints } from '../endpoints.js'
import { SerializerFactory } from '../serializers/serializerFactory.js'
import { cacheManager } from '../storage/cacheManager.js' // ⬅️ Add this

export class RequestManager {
  constructor() {
    this.setup()
  }

  setup() {
    const actions = [
      'GET_DATA',
      'POST_DATA',
      'PUT_DATA',
      'PATCH_DATA',
      'DELETE_DATA',
    ]

    actions.forEach(action => {
      eventBus.on(action, async ({ entityType, payload, requestId }) => {
        try {
          const method = this.getMethod(action)
          const url = this.getUrl(entityType, method, payload)
          if (method === 'GET') {
            const cached = await cacheManager.get(method, url)
            if (cached) {
              return eventBus.emit(`RESPONSE:${requestId}`, {
                statusCode: 200,
                message: 'Loaded from cache',
                data: cached,
              })
            }
          }

          const options = this.buildOptions(method, payload, entityType)
          const response = await fetch(url, options)
          const data = await response.json()

          const serializer = SerializerFactory.get(entityType)
          const finalData = serializer.deserialize(data, payload, method) || {}
          finalData.raw = data
          
          eventBus.emit(`RESPONSE:${requestId}`, {
            statusCode: 200,
            message: 'Successful request',
            data: finalData,
          })
        } catch (error) {
          eventBus.emit(`RESPONSE:${requestId}`, {
            statusCode: 500,
            message: 'Request failed',
            error: error.message,
          })
        }
      })
    })
  }

  getMethod(action) {
    const map = {
      GET_DATA: 'GET',
      POST_DATA: 'POST',
      PUT_DATA: 'PUT',
      PATCH_DATA: 'PATCH',
      DELETE_DATA: 'DELETE',
    }
    return map[action]
  }

  getUrl(entityType, method, payload) {
    const endpoint = endpoints[entityType]
    if (!endpoint || !endpoint[method]) {
      throw new Error(`No URL available for ${method} method on ${entityType}`)
    }
    return endpoint[method](payload)
  }

  buildOptions(method, payload, entityType) {
    const options = {
      method,
    }

    if (['POST', 'PUT', 'PATCH'].includes(method) && payload) {
      const serializer = SerializerFactory.get(entityType)
      const serializedPayload = serializer.serialize(payload)
      options.headers = { 'Content-Type': 'application/json' }
      options.body = JSON.stringify(serializedPayload)
    }

    return options
  }
}
